import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`
      });
      
      if (error) throw error;
      
      setSent(true);
      toast.success('Reset instructions sent to your email');
    } catch (error) {
      console.error('Reset password error:', error);
      // Still show success to prevent email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <div className="w-full max-w-md text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="heading-display text-2xl font-medium mb-4">Controlla la tua Email</h1>
          <p className="text-muted-foreground mb-8">
            Se esiste un account con <strong>{email}</strong>, riceverai le istruzioni per reimpostare la password.
          </p>
          <Link to="/login">
            <Button className="w-full py-6">Torna al Login</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-8">
          <ArrowLeft className="w-4 h-4" /> Torna al login
        </Link>
        
        <div className="bg-white border border-border p-8">
          <div className="text-center mb-8">
            <div className="w-12 h-12 bg-secondary rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-muted-foreground" />
            </div>
            <h1 className="heading-display text-2xl font-medium mb-2">Reimposta Password</h1>
            <p className="text-muted-foreground text-sm">
              Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="caption-text mb-2 block">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-field w-full"
                placeholder="you@example.com"
                required
              />
            </div>

            <Button 
              type="submit" 
              className="btn-primary w-full py-6" 
              disabled={loading}
            >
              {loading ? 'Invio in corso...' : 'Invia Istruzioni'}
            </Button>
          </form>

          <p className="text-center text-sm text-muted-foreground mt-6">
            Ricordi la password?{' '}
            <Link to="/login" className="text-primary hover:underline">
              Accedi
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
